module.exports = __webpack_public_path__ + "img/upload-photo-circle.5aabf0d8.svg";